import { useEffect, useState } from "react";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import PropertyCard from "@/components/PropertyCard";
import { EmptyState, Overline } from "@/components/shared";
import { useContent } from "@/context/ContentContext";
import { Input } from "@/components/ui/input";
import { Search, Home } from "lucide-react";

export default function Browse() {
  const { c } = useContent();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [city, setCity] = useState("");

  const load = () => {
    setLoading(true);
    api
      .get("/properties", { params: city ? { city } : {} })
      .then((r) => setProperties(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen bg-bone">
      <Navbar />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10">
        <Overline>{c("browse_overline")}</Overline>
        <h1 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight text-ink">{c("browse_title")}</h1>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            load();
          }}
          className="mt-6 flex gap-3 max-w-md"
        >
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-mute" />
            <Input
              data-testid="browse-city-input"
              placeholder="Search by city…"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              className="pl-9 bg-white border-line"
            />
          </div>
          <button data-testid="browse-search-btn" type="submit" className="bg-forest text-white px-5 rounded-lg font-medium hover:bg-forest-hover transition-colors">
            Search
          </button>
        </form>

        <div className="mt-8">
          {loading ? (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="h-80 rounded-xl bg-white border border-line animate-pulse" />
              ))}
            </div>
          ) : properties.length === 0 ? (
            <div className="bg-white border border-line rounded-xl">
              <EmptyState icon={Home} title="No homes found" subtitle="Try a different city or clear your search." />
            </div>
          ) : (
            <div data-testid="properties-grid" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {properties.map((p, i) => (
                <PropertyCard key={p.id} property={p} index={i} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
